import { z } from 'zod';

export const VisualCardSchema = z.object({
  src: z.string().min(1, 'image path is required').regex(/^\//, 'src must start with /'),
  title: z.string().min(1, 'title is required'),
  desc: z.string().min(1, 'description is required'),
});

export type VisualCard = z.infer<typeof VisualCardSchema>;
export const VisualsSchema = z.array(VisualCardSchema);
